<template>
  <!--eslint-disabled-->

  <svg
    v-if="name === 'mobileBackBtn'"
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="22"
    viewBox="0 0 12 22"
    fill="none"
  >
    <path
      d="M2.71088 11L10.7977 2.27302C11.0728 1.97614 11.0666 1.50131 10.7838 1.21246C10.5011 0.923602 10.0489 0.930107 9.77377 1.22698L1.20234 10.477C0.932554 10.7681 0.932554 11.2319 1.20234 11.523L9.77377 20.773C10.0489 21.0699 10.5011 21.0764 10.7838 20.7875C11.0666 20.4987 11.0728 20.0239 10.7977 19.727L2.71088 11Z"
      fill="white"
      stroke="white"
    />
  </svg>

  <svg
    v-if="name === 'photoSwiperPrev'"
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
  >
    <path
      d="M10 1L2 9L10 17"
      stroke="#4B94FF"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>

  <svg
    v-if="name === 'photoSwiperNext'"
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
  >
    <path
      d="M1 1L9 9L1 17"
      stroke="#4B94FF"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>

  <svg
    v-if="name === 'notification'"
    width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.99951 7.49976H9.99951V8.49976H-0.000488281V7.49976H0.999512V3.99976C0.999512 2.93889 1.42094 1.92147 2.17108 1.17133C2.92123 0.421183 3.93865 -0.000244141 4.99951 -0.000244141C6.06038 -0.000244141 7.07779 0.421183 7.82794 1.17133C8.57808 1.92147 8.99951 2.93889 8.99951 3.99976V7.49976ZM3.49951 9.49976H6.49951V10.4998H3.49951V9.49976Z" fill="#304156"/>
  </svg>

  <svg
    v-if="name === 'usersHeader'"
    class="icon"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.99935 10.0531C8.71601 10.0531 7.66602 9.62771 6.84935 8.77702C6.03268 7.92632 5.62435 6.83257 5.62435 5.49577C5.62435 4.15896 6.03268 3.06521 6.84935 2.21452C7.66602 1.36382 8.71601 0.938477 9.99935 0.938477C11.2827 0.938477 12.3327 1.36382 13.1493 2.21452C13.966 3.06521 14.3743 4.15896 14.3743 5.49577C14.3743 6.83257 13.966 7.92632 13.1493 8.77702C12.3327 9.62771 11.2827 10.0531 9.99935 10.0531ZM0.666016 19.8057V16.9498C0.666016 16.1801 0.850738 15.5218 1.22018 14.9749C1.58963 14.4281 2.06602 14.0128 2.64935 13.7293C3.95213 13.1216 5.20143 12.6659 6.39727 12.3621C7.5931 12.0583 8.79379 11.9064 9.99935 11.9064C11.2049 11.9064 12.4007 12.0633 13.5868 12.3773C14.773 12.6912 16.0174 13.1419 17.3202 13.7293C17.923 14.0128 18.4091 14.4281 18.7785 14.9749C19.148 15.5218 19.3327 16.1801 19.3327 16.9498V19.8057H0.666016ZM2.41602 17.9827H17.5827V16.9498C17.5827 16.6257 17.4903 16.3168 17.3056 16.0231C17.1209 15.7294 16.8924 15.5117 16.6202 15.3699C15.3757 14.742 14.2382 14.3116 13.2077 14.0787C12.1771 13.8457 11.1077 13.7293 9.99935 13.7293C8.89102 13.7293 7.81185 13.8457 6.76185 14.0787C5.71185 14.3116 4.57435 14.742 3.34935 15.3699C3.07713 15.5117 2.85352 15.7294 2.67852 16.0231C2.50352 16.3168 2.41602 16.6257 2.41602 16.9498V17.9827ZM9.99935 8.23014C10.7577 8.23014 11.3848 7.9719 11.8806 7.4554C12.3764 6.93891 12.6243 6.2857 12.6243 5.49577C12.6243 4.70584 12.3764 4.05263 11.8806 3.53613C11.3848 3.01964 10.7577 2.76139 9.99935 2.76139C9.24102 2.76139 8.61393 3.01964 8.1181 3.53613C7.62227 4.05263 7.37435 4.70584 7.37435 5.49577C7.37435 6.2857 7.62227 6.93891 8.1181 7.4554C8.61393 7.9719 9.24102 8.23014 9.99935 8.23014Z"
      fill="black"
    />
  </svg>

  <svg
    v-if="name === 'usersHeaderMobile'"
    class="icon-mobile"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_1632_19429)">
      <path
        d="M13.3692 11.667H6.63083C5.53567 11.6683 4.48575 12.104 3.71135 12.8783C2.93696 13.6527 2.50132 14.7027 2.5 15.7978V20.0003H17.5V15.7978C17.4987 14.7027 17.063 13.6527 16.2886 12.8783C15.5143 12.104 14.4643 11.6683 13.3692 11.667Z"
        fill="#333333"
      />
      <path
        d="M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z"
        fill="#333333"
      />
    </g>
    <defs>
      <clipPath id="clip0_1632_19429">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-if="name === 'usersTableUser'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_1632_19090)">
      <path
        d="M13.3692 11.667H6.63083C5.53567 11.6683 4.48575 12.104 3.71135 12.8783C2.93696 13.6527 2.50132 14.7027 2.5 15.7978V20.0003H17.5V15.7978C17.4987 14.7027 17.063 13.6527 16.2886 12.8783C15.5143 12.104 14.4643 11.6683 13.3692 11.667Z"
        fill="white"
      />
      <path
        d="M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1632_19090">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-if="name === 'empty-placeholder'"
    width="100"
    height="96"
    viewBox="0 0 100 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 0C4.47715 0 0 4.47715 0 10V86C0 91.5229 4.47716 96 10 96H90C95.5229 96 100 91.5228 100 86V10C100 4.47715 95.5228 0 90 0H10ZM94 28H6V80C6 85.5229 10.4772 90 16 90H84C89.5229 90 94 85.5228 94 80V28ZM21 49C21 46.7909 22.7909 45 25 45C27.2091 45 29 46.7909 29 49C29 51.2091 27.2091 53 25 53C22.7909 53 21 51.2091 21 49ZM45 45C42.7909 45 41 46.7909 41 49C41 51.2091 42.7909 53 45 53H75C77.2091 53 79 51.2091 79 49C79 46.7909 77.2091 45 75 45H45ZM41 68C41 65.7909 42.7909 64 45 64H75C77.2091 64 79 65.7909 79 68C79 70.2091 77.2091 72 75 72H45C42.7909 72 41 70.2091 41 68ZM25 64C22.7909 64 21 65.7909 21 68C21 70.2091 22.7909 72 25 72C27.2091 72 29 70.2091 29 68C29 65.7909 27.2091 64 25 64Z"
      fill="#ABABAB"
    />
  </svg>

  <svg
    v-if="name === 'usersTableApprove'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 0C15.523 0 20 4.47701 20 10C20 15.523 15.523 20 10 20C4.47701 20 0 15.523 0 10C0 4.47701 4.47701 0 10 0ZM8.85725 13.7765L14.7073 7.9265C15.0983 7.5365 15.0983 6.9035 14.7073 6.5125C14.3163 6.1225 13.6842 6.1225 13.2933 6.5125L8.85725 10.9485L6.70725 8.7985C6.31625 8.4075 5.68425 8.4075 5.29325 8.7985C4.90225 9.1895 4.90225 9.8215 5.29325 10.2125L8.85725 13.7765Z"
      fill="#59CB47"
    />
  </svg>

  <svg
    v-if="name === 'userBackBtnArrow'"
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="22"
    viewBox="0 0 12 22"
    fill="none"
  >
    <path
      d="M2.71088 11L10.7977 2.27302C11.0728 1.97614 11.0666 1.50131 10.7838 1.21246C10.5011 0.923602 10.0489 0.930107 9.77377 1.22698L1.20234 10.477C0.932554 10.7681 0.932554 11.2319 1.20234 11.523L9.77377 20.773C10.0489 21.0699 10.5011 21.0764 10.7838 20.7875C11.0666 20.4987 11.0728 20.0239 10.7977 19.727L2.71088 11Z"
      fill="white"
      stroke="white"
    />
  </svg>

  <svg
    v-if="name === 'userBackBtn'"
    class="icon"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.99935 9.55306C8.71601 9.55306 7.66602 9.12771 6.84935 8.27702C6.03268 7.42632 5.62435 6.33257 5.62435 4.99577C5.62435 3.65896 6.03268 2.56521 6.84935 1.71452C7.66602 0.863824 8.71601 0.438477 9.99935 0.438477C11.2827 0.438477 12.3327 0.863824 13.1493 1.71452C13.966 2.56521 14.3743 3.65896 14.3743 4.99577C14.3743 6.33257 13.966 7.42632 13.1493 8.27702C12.3327 9.12771 11.2827 9.55306 9.99935 9.55306ZM0.666016 19.3057V16.4498C0.666016 15.6801 0.850738 15.0218 1.22018 14.4749C1.58963 13.9281 2.06602 13.5128 2.64935 13.2293C3.95213 12.6216 5.20143 12.1659 6.39727 11.8621C7.5931 11.5583 8.79379 11.4064 9.99935 11.4064C11.2049 11.4064 12.4007 11.5633 13.5868 11.8773C14.773 12.1912 16.0174 12.6419 17.3202 13.2293C17.923 13.5128 18.4091 13.9281 18.7785 14.4749C19.148 15.0218 19.3327 15.6801 19.3327 16.4498V19.3057H0.666016ZM2.41602 17.4827H17.5827V16.4498C17.5827 16.1257 17.4903 15.8168 17.3056 15.5231C17.1209 15.2294 16.8924 15.0117 16.6202 14.8699C15.3757 14.242 14.2382 13.8116 13.2077 13.5787C12.1771 13.3457 11.1077 13.2293 9.99935 13.2293C8.89102 13.2293 7.81185 13.3457 6.76185 13.5787C5.71185 13.8116 4.57435 14.242 3.34935 14.8699C3.07713 15.0117 2.85352 15.2294 2.67852 15.5231C2.50352 15.8168 2.41602 16.1257 2.41602 16.4498V17.4827ZM9.99935 7.73014C10.7577 7.73014 11.3848 7.4719 11.8806 6.9554C12.3764 6.43891 12.6243 5.7857 12.6243 4.99577C12.6243 4.20584 12.3764 3.55263 11.8806 3.03613C11.3848 2.51964 10.7577 2.26139 9.99935 2.26139C9.24102 2.26139 8.61393 2.51964 8.1181 3.03613C7.62227 3.55263 7.37435 4.20584 7.37435 4.99577C7.37435 5.7857 7.62227 6.43891 8.1181 6.9554C8.61393 7.4719 9.24102 7.73014 9.99935 7.73014Z"
      fill="white"
    />
  </svg>

  <svg
    v-if="name === 'userBackBtnMobile'"
    class="icon-mobile"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_1632_19553)">
      <path
        d="M13.3692 11.667H6.63083C5.53567 11.6683 4.48575 12.104 3.71135 12.8783C2.93696 13.6527 2.50132 14.7027 2.5 15.7978V20.0003H17.5V15.7978C17.4987 14.7027 17.063 13.6527 16.2886 12.8783C15.5143 12.104 14.4643 11.6683 13.3692 11.667Z"
        fill="white"
      />
      <path
        d="M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1632_19553">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-if="name === 'userVerifyBtn'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_1632_19553)">
      <path
        d="M13.3692 11.667H6.63083C5.53567 11.6683 4.48575 12.104 3.71135 12.8783C2.93696 13.6527 2.50132 14.7027 2.5 15.7978V20.0003H17.5V15.7978C17.4987 14.7027 17.063 13.6527 16.2886 12.8783C15.5143 12.104 14.4643 11.6683 13.3692 11.667Z"
        fill="white"
      />
      <path
        d="M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1632_19553">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-if="name === 'realEstateIcon'"
    class="icon"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M4.16667 13.5417H7.29167V15.625H4.16667V13.5417ZM9.375 15.625H12.5V13.5417H9.375V15.625ZM4.16667 19.7917H7.29167V17.7083H4.16667V19.7917ZM9.375 19.7917H12.5V17.7083H9.375V19.7917ZM4.16667 7.29167H7.29167V5.20833H4.16667V7.29167ZM9.375 7.29167H12.5V5.20833H9.375V7.29167ZM4.16667 11.4583H7.29167V9.375H4.16667V11.4583ZM9.375 11.4583H12.5V9.375H9.375V11.4583ZM25 8.33333V25H0V3.125C0 2.2962 0.32924 1.50134 0.915291 0.915291C1.50134 0.32924 2.2962 0 3.125 0L13.5417 0C14.3705 0 15.1653 0.32924 15.7514 0.915291C16.3374 1.50134 16.6667 2.2962 16.6667 3.125V5.20833H21.875C22.7038 5.20833 23.4987 5.53757 24.0847 6.12362C24.6708 6.70968 25 7.50453 25 8.33333ZM14.5833 3.125C14.5833 2.84873 14.4736 2.58378 14.2782 2.38843C14.0829 2.19308 13.8179 2.08333 13.5417 2.08333H3.125C2.84873 2.08333 2.58378 2.19308 2.38843 2.38843C2.19308 2.58378 2.08333 2.84873 2.08333 3.125V22.9167H14.5833V3.125ZM22.9167 8.33333C22.9167 8.05707 22.8069 7.79211 22.6116 7.59676C22.4162 7.40141 22.1513 7.29167 21.875 7.29167H16.6667V22.9167H22.9167V8.33333ZM18.75 15.625H20.8333V13.5417H18.75V15.625ZM18.75 19.7917H20.8333V17.7083H18.75V19.7917ZM18.75 11.4583H20.8333V9.375H18.75V11.4583Z"
      fill="#304156"
    />
  </svg>

  <svg
    v-if="name === 'realEstateMobileIcon'"
    class="icon-mobile"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.16667 0H2.5C1.83696 0 1.20107 0.263392 0.732233 0.732233C0.263392 1.20107 0 1.83696 0 2.5L0 20H11.6667V2.5C11.6667 1.83696 11.4033 1.20107 10.9344 0.732233C10.4656 0.263392 9.82971 0 9.16667 0V0ZM5 15.8333H2.5V14.1667H5V15.8333ZM5 12.5H2.5V10.8333H5V12.5ZM5 9.16667H2.5V7.5H5V9.16667ZM5 5.83333H2.5V4.16667H5V5.83333ZM9.16667 15.8333H6.66667V14.1667H9.16667V15.8333ZM9.16667 12.5H6.66667V10.8333H9.16667V12.5ZM9.16667 9.16667H6.66667V7.5H9.16667V9.16667ZM9.16667 5.83333H6.66667V4.16667H9.16667V5.83333ZM17.5 4.16667H13.3333V20H20V6.66667C20 6.00363 19.7366 5.36774 19.2678 4.8989C18.7989 4.43006 18.163 4.16667 17.5 4.16667ZM17.5 15.8333H15.8333V14.1667H17.5V15.8333ZM17.5 12.5H15.8333V10.8333H17.5V12.5ZM17.5 9.16667H15.8333V7.5H17.5V9.16667Z"
      fill="#333333"
    />
  </svg>

  <svg
    v-if="name === 'realEstateDetailsIcon'"
    class="icon"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="26"
    viewBox="0 0 25 26"
    fill="none"
  >
    <path
      d="M4.16667 14.0417H7.29167V16.125H4.16667V14.0417ZM9.375 16.125H12.5V14.0417H9.375V16.125ZM4.16667 20.2917H7.29167V18.2083H4.16667V20.2917ZM9.375 20.2917H12.5V18.2083H9.375V20.2917ZM4.16667 7.79167H7.29167V5.70833H4.16667V7.79167ZM9.375 7.79167H12.5V5.70833H9.375V7.79167ZM4.16667 11.9583H7.29167V9.875H4.16667V11.9583ZM9.375 11.9583H12.5V9.875H9.375V11.9583ZM25 8.83333V25.5H0V3.625C0 2.7962 0.32924 2.00134 0.915291 1.41529C1.50134 0.82924 2.2962 0.5 3.125 0.5L13.5417 0.5C14.3705 0.5 15.1653 0.82924 15.7514 1.41529C16.3374 2.00134 16.6667 2.7962 16.6667 3.625V5.70833H21.875C22.7038 5.70833 23.4987 6.03757 24.0847 6.62362C24.6708 7.20968 25 8.00453 25 8.83333ZM14.5833 3.625C14.5833 3.34873 14.4736 3.08378 14.2782 2.88843C14.0829 2.69308 13.8179 2.58333 13.5417 2.58333H3.125C2.84873 2.58333 2.58378 2.69308 2.38843 2.88843C2.19308 3.08378 2.08333 3.34873 2.08333 3.625V23.4167H14.5833V3.625ZM22.9167 8.83333C22.9167 8.55707 22.8069 8.29211 22.6116 8.09676C22.4162 7.90141 22.1513 7.79167 21.875 7.79167H16.6667V23.4167H22.9167V8.83333ZM18.75 16.125H20.8333V14.0417H18.75V16.125ZM18.75 20.2917H20.8333V18.2083H18.75V20.2917ZM18.75 11.9583H20.8333V9.875H18.75V11.9583Z"
      fill="white"
    />
  </svg>

  <svg
    v-if="name === 'realEstateDetailsMobileIcon'"
    class="icon-mobile"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.16667 0H2.5C1.83696 0 1.20107 0.263392 0.732233 0.732233C0.263392 1.20107 0 1.83696 0 2.5L0 20H11.6667V2.5C11.6667 1.83696 11.4033 1.20107 10.9344 0.732233C10.4656 0.263392 9.82971 0 9.16667 0V0ZM5 15.8333H2.5V14.1667H5V15.8333ZM5 12.5H2.5V10.8333H5V12.5ZM5 9.16667H2.5V7.5H5V9.16667ZM5 5.83333H2.5V4.16667H5V5.83333ZM9.16667 15.8333H6.66667V14.1667H9.16667V15.8333ZM9.16667 12.5H6.66667V10.8333H9.16667V12.5ZM9.16667 9.16667H6.66667V7.5H9.16667V9.16667ZM9.16667 5.83333H6.66667V4.16667H9.16667V5.83333ZM17.5 4.16667H13.3333V20H20V6.66667C20 6.00363 19.7366 5.36774 19.2678 4.8989C18.7989 4.43006 18.163 4.16667 17.5 4.16667ZM17.5 15.8333H15.8333V14.1667H17.5V15.8333ZM17.5 12.5H15.8333V10.8333H17.5V12.5ZM17.5 9.16667H15.8333V7.5H17.5V9.16667Z"
      fill="white"
    />
  </svg>

  <svg
    v-if="name === 'detailsApproved'"
    class="icon"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 0.5C15.523 0.5 20 4.97701 20 10.5C20 16.023 15.523 20.5 10 20.5C4.47701 20.5 0 16.023 0 10.5C0 4.97701 4.47701 0.5 10 0.5ZM8.85725 14.2765L14.7073 8.4265C15.0983 8.0365 15.0983 7.4035 14.7073 7.0125C14.3163 6.6225 13.6842 6.6225 13.2933 7.0125L8.85725 11.4485L6.70725 9.2985C6.31625 8.9075 5.68425 8.9075 5.29325 9.2985C4.90225 9.6895 4.90225 10.3215 5.29325 10.7125L8.85725 14.2765Z"
      fill="#59CB47"
    />
  </svg>

  <svg
    v-if="name === 'detailsApprovedMobile'"
    class="icon-mobile"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5 0.5C11.6422 0.5 15 3.85776 15 8C15 12.1422 11.6422 15.5 7.5 15.5C3.35776 15.5 0 12.1422 0 8C0 3.85776 3.35776 0.5 7.5 0.5ZM6.64294 10.8324L11.0304 6.44488C11.3237 6.15238 11.3237 5.67762 11.0304 5.38437C10.7372 5.09188 10.2632 5.09188 9.96994 5.38437L6.64294 8.71138L5.03044 7.09888C4.73719 6.80562 4.26319 6.80562 3.96994 7.09888C3.67669 7.39213 3.67669 7.86613 3.96994 8.15938L6.64294 10.8324Z"
      fill="#59CB47"
    />
  </svg>

  <svg
    v-if="name === 'downloadDocumentsBtn'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z"
      fill="#304156"
    />
    <path
      d="M10.5905 12.3818L12.0688 10.7813L12.0705 10.7795L12.0705 10.7796C12.1814 10.6706 12.3276 10.6112 12.479 10.6151C12.6304 10.6189 12.7737 10.6857 12.8796 10.8001C12.9854 10.9143 13.046 11.0675 13.0498 11.2278C13.0536 11.388 13.0004 11.5442 12.9002 11.6641L12.8986 11.666L12.8986 11.666L11.1811 13.5249C11.1811 13.5249 11.1811 13.5249 11.1811 13.5249C11.0276 13.6911 10.8452 13.8231 10.6441 13.9133C10.443 14.0035 10.2273 14.05 10.0093 14.05C9.79139 14.05 9.57568 14.0035 9.37458 13.9133C9.1735 13.8231 8.99108 13.6911 8.83763 13.5249L10.5905 12.3818ZM10.5905 12.3818L10.5942 3.57893V3.57891C10.5942 3.41333 10.5335 3.25382 10.4243 3.13563C10.315 3.0173 10.1658 2.95 10.0093 2.95H9.95935V2.9523C9.82139 2.96501 9.69202 3.02998 9.59441 3.13563C9.48521 3.25381 9.42447 3.41331 9.42447 3.57888C9.42447 3.57889 9.42447 3.5789 9.42447 3.57891L9.41972 12.371L7.94986 10.7813C7.84048 10.663 7.69126 10.5957 7.53478 10.5958C7.3783 10.5958 7.22913 10.6632 7.11982 10.7816C7.01064 10.8999 6.94995 11.0594 6.95 11.225C6.95005 11.3906 7.01085 11.5502 7.12012 11.6683L7.12013 11.6683L8.8376 13.5249L10.5905 12.3818Z"
      fill="white"
      stroke="white"
      stroke-width="0.1"
    />
    <path
      d="M16.4167 12C16.262 12 16.1136 12.0658 16.0042 12.1831C15.8948 12.3003 15.8333 12.4592 15.8333 12.625V15.125C15.8333 15.2908 15.7719 15.4497 15.6625 15.5669C15.5531 15.6842 15.4047 15.75 15.25 15.75H4.75C4.59529 15.75 4.44692 15.6842 4.33752 15.5669C4.22812 15.4497 4.16667 15.2908 4.16667 15.125V12.625C4.16667 12.4592 4.10521 12.3003 3.99581 12.1831C3.88642 12.0658 3.73804 12 3.58333 12C3.42862 12 3.28025 12.0658 3.17085 12.1831C3.06146 12.3003 3 12.4592 3 12.625V15.125C3 15.6223 3.18437 16.0992 3.51256 16.4508C3.84075 16.8025 4.28587 17 4.75 17H15.25C15.7141 17 16.1592 16.8025 16.4874 16.4508C16.8156 16.0992 17 15.6223 17 15.125V12.625C17 12.4592 16.9385 12.3003 16.8291 12.1831C16.7197 12.0658 16.5714 12 16.4167 12Z"
      fill="white"
    />
  </svg>

  <svg
    v-if="name === 'adjustmentTypeGreen'"
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="15"
    viewBox="0 0 40 15"
    fill="none"
  >
    <path
      d="M30.4388 5.23309H2.53445C1.1405 5.23309 0 6.25722 0 7.50894C0 8.76066 1.1405 9.7848 2.53445 9.7848H30.4388V13.8586C30.4388 14.8827 31.8074 15.3834 32.5931 14.6551L39.6388 8.30549C40.1204 7.85032 40.1204 7.14481 39.6388 6.68964L32.5931 0.340001C31.8074 -0.388273 30.4388 0.135173 30.4388 1.13655V5.23309Z"
      fill="#59CB47"
    />
  </svg>

  <svg
    v-if="name === 'adjustmentTypeRed'"
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="15"
    viewBox="0 0 40 15"
    fill="none"
  >
    <path
      d="M9.56122 9.76691L37.4655 9.76691C38.8595 9.76691 40 8.74278 40 7.49106C40 6.23934 38.8595 5.2152 37.4655 5.2152L9.56122 5.2152V1.14142C9.56122 0.117287 8.19261 -0.383402 7.40693 0.344872L0.361156 6.69451C-0.120388 7.14968 -0.120388 7.85519 0.361156 8.31036L7.40693 14.66C8.19261 15.3883 9.56122 14.8648 9.56122 13.8635V9.76691Z"
      fill="#FF4141"
    />
  </svg>

  <svg
    v-if="name === 'adjustmentAgreeBtn'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_1632_25861)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0C15.523 0 20 4.47701 20 10C20 15.523 15.523 20 10 20C4.47701 20 0 15.523 0 10C0 4.47701 4.47701 0 10 0ZM8.85725 13.7765L14.7073 7.9265C15.0983 7.5365 15.0983 6.9035 14.7073 6.5125C14.3163 6.1225 13.6843 6.1225 13.2933 6.5125L8.85725 10.9485L6.70725 8.7985C6.31625 8.4075 5.68425 8.4075 5.29325 8.7985C4.90225 9.1895 4.90225 9.8215 5.29325 10.2125L8.85725 13.7765Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1632_25861">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-if="name === 'adjustmentRejectBtn'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C19.994 4.47961 15.5204 0.00597656 10 0ZM13.3333 12.1558C13.672 12.4675 13.6938 12.9947 13.3821 13.3333C13.0705 13.672 12.5433 13.6938 12.2046 13.3821C12.1877 13.3666 12.1714 13.3503 12.1558 13.3333L10 11.1783L7.845 13.3333C7.51395 13.653 6.98641 13.6439 6.66668 13.3128C6.3548 12.9899 6.3548 12.4779 6.66668 12.155L8.82168 10L6.66668 7.845C6.34695 7.51395 6.35613 6.98641 6.68719 6.66668C7.01012 6.3548 7.52207 6.3548 7.845 6.66668L10 8.82168L12.1558 6.66668C12.4675 6.32805 12.9947 6.30617 13.3333 6.61785C13.672 6.92953 13.6938 7.45672 13.3821 7.79535C13.3666 7.8123 13.3503 7.82856 13.3333 7.84418L11.1783 10L13.3333 12.1558Z"
      fill="white"
    />
  </svg>

  <svg
    v-if="name === 'popUpConfirm'"
    class="icon"
    xmlns="http://www.w3.org/2000/svg"
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M57 0C88.481 0 114 25.519 114 57C114 88.481 88.481 114 57 114C25.519 114 0 88.481 0 57C0 25.519 25.519 0 57 0ZM50.4863 78.5261L83.8313 45.181C86.06 42.958 86.06 39.3499 83.8313 37.1212C81.6026 34.8982 78.0002 34.8982 75.7715 37.1212L50.4863 62.4065L38.2313 50.1514C36.0026 47.9227 32.4002 47.9227 30.1715 50.1514C27.9428 52.3801 27.9428 55.9826 30.1715 58.2113L50.4863 78.5261Z"
      fill="#304156"
    />
  </svg>

  <svg
    v-if="name === 'popUpConfirmMobile'"
    class="icon-mobile"
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30 0C46.569 0 60 13.431 60 30C60 46.569 46.569 60 30 60C13.431 60 0 46.569 0 30C0 13.431 13.431 0 30 0ZM26.5718 41.3295L44.1217 23.7795C45.2948 22.6095 45.2948 20.7105 44.1217 19.5375C42.9488 18.3675 41.0527 18.3675 39.8797 19.5375L26.5718 32.8455L20.1217 26.3955C18.9487 25.2225 17.0527 25.2225 15.8798 26.3955C14.7067 27.5685 14.7067 29.4645 15.8798 30.6375L26.5718 41.3295Z"
      fill="#304156"
    />
  </svg>

  <svg
    v-if="name === 'uah'"
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="16"
    viewBox="0 0 11 16"
    fill="none"
  >
    <path
      d="M5.8 15.2C4.76 15.2 3.88 15.06 3.16 14.78C2.44 14.5 1.88667 14.0867 1.5 13.54C1.12667 12.98 0.94 12.2733 0.94 11.42C0.94 11.1667 0.96 10.9267 1 10.7C1.04 10.46 1.09333 10.24 1.16 10.04H0.22V8.76H1.9C2.16667 8.49333 2.52 8.25333 2.96 8.04C3.41333 7.81333 3.88 7.61333 4.36 7.44C4.85333 7.26667 5.28667 7.12 5.66 7C6.03333 6.86667 6.27333 6.77333 6.38 6.72H0.22V5.44H7.86C7.96667 5.25333 8.04 5.06 8.08 4.86C8.13333 4.66 8.16 4.40667 8.16 4.1C8.16 3.68667 8.06667 3.33333 7.88 3.04C7.69333 2.73333 7.40667 2.5 7.02 2.34C6.63333 2.18 6.13333 2.1 5.52 2.1C5.08 2.1 4.65333 2.14 4.24 2.22C3.84 2.3 3.46 2.40667 3.1 2.54C2.75333 2.66 2.42667 2.79333 2.12 2.94L1.62 1.36C2.12667 1.12 2.74667 0.919999 3.48 0.76C4.21333 0.599999 4.92667 0.519999 5.62 0.519999C6.52667 0.519999 7.3 0.646666 7.94 0.899999C8.59333 1.14 9.09333 1.50667 9.44 2C9.8 2.49333 9.98 3.12 9.98 3.88C9.98 4.16 9.96 4.44 9.92 4.72C9.88 4.98667 9.80667 5.22667 9.7 5.44H10.8V6.72H9.06C8.84667 6.93333 8.51333 7.15333 8.06 7.38C7.60667 7.59333 7.13333 7.79333 6.64 7.98C6.14667 8.16667 5.7 8.32667 5.3 8.46C4.9 8.59333 4.64 8.69333 4.52 8.76H10.8V10.04H3.02C2.91333 10.24 2.84 10.4267 2.8 10.6C2.76 10.7733 2.74 11.0133 2.74 11.32C2.74 11.84 2.86 12.2733 3.1 12.62C3.34 12.9533 3.7 13.2067 4.18 13.38C4.66 13.5533 5.25333 13.64 5.96 13.64C6.72 13.64 7.45333 13.5467 8.16 13.36C8.88 13.16 9.48 12.9533 9.96 12.74V14.36C9.50667 14.5733 8.9 14.7667 8.14 14.94C7.38 15.1133 6.6 15.2 5.8 15.2Z"
      fill="#304156"
    />
  </svg>
  <svg
    v-if="name === 'showPassword'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.30974 8.47275C2.58756 7.75022 1.98017 6.91584 1.50973 6C1.98017 5.08416 2.58756 4.24978 3.30974 3.52725C4.39997 2.44875 5.9371 1.5 8 1.5C10.0629 1.5 11.6 2.44875 12.6903 3.52725C13.4124 4.24978 14.0198 5.08416 14.4903 6C14.0198 6.91584 13.4125 7.75023 12.6903 8.47275C11.6 9.55125 10.0629 10.5 8 10.5C5.9371 10.5 4.39997 9.55125 3.30974 8.47275ZM8 0C5.45661 0 3.57481 1.18275 2.29691 2.4465C1.40178 3.33915 0.660768 4.38147 0.105496 5.529C0.0360734 5.67564 0 5.83657 0 5.99963C0 6.16268 0.0360734 6.32361 0.105496 6.47025C0.660477 7.61799 1.40124 8.66057 2.29618 9.5535C3.57481 10.8173 5.45734 12 8 12C10.5434 12 12.4252 10.8173 13.7031 9.5535C14.5982 8.66087 15.3393 7.61854 15.8945 6.471C15.9639 6.32436 16 6.16343 16 6.00037C16 5.83732 15.9639 5.67639 15.8945 5.52975C15.3395 4.382 14.5988 3.33942 13.7038 2.4465C12.4252 1.18275 10.5434 0 8 0ZM6.53954 6C6.53954 5.60218 6.69341 5.22064 6.9673 4.93934C7.24119 4.65804 7.61266 4.5 8 4.5C8.38734 4.5 8.75881 4.65804 9.0327 4.93934C9.30659 5.22064 9.46046 5.60218 9.46046 6C9.46046 6.39782 9.30659 6.77936 9.0327 7.06066C8.75881 7.34196 8.38734 7.5 8 7.5C7.61266 7.5 7.24119 7.34196 6.9673 7.06066C6.69341 6.77936 6.53954 6.39782 6.53954 6ZM8 3C7.22533 3 6.48238 3.31607 5.9346 3.87868C5.38682 4.44129 5.07908 5.20435 5.07908 6C5.07908 6.79565 5.38682 7.55871 5.9346 8.12132C6.48238 8.68393 7.22533 9 8 9C8.77468 9 9.51762 8.68393 10.0654 8.12132C10.6132 7.55871 10.9209 6.79565 10.9209 6C10.9209 5.20435 10.6132 4.44129 10.0654 3.87868C9.51762 3.31607 8.77468 3 8 3Z"
      :fill="isError ? '#FF4141' : '#304156'"
    />
  </svg>

  <svg
    v-if="name === 'hidePassword'"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.30974 8.47275C3.58756 7.75022 2.98017 6.91584 2.50973 6C2.98017 5.08416 3.58756 4.24978 4.30974 3.52725C5.39997 2.44875 6.9371 1.5 9 1.5C11.0629 1.5 12.6 2.44875 13.6903 3.52725C14.4124 4.24978 15.0198 5.08416 15.4903 6C15.0198 6.91584 14.4125 7.75023 13.6903 8.47275C12.6 9.55125 11.0629 10.5 9 10.5C6.9371 10.5 5.39997 9.55125 4.30974 8.47275ZM9 0C6.45661 0 4.57481 1.18275 3.29691 2.4465C2.40178 3.33915 1.66077 4.38147 1.1055 5.529C1.03607 5.67564 1 5.83657 1 5.99963C1 6.16268 1.03607 6.32361 1.1055 6.47025C1.66048 7.61799 2.40124 8.66057 3.29618 9.5535C4.57481 10.8173 6.45734 12 9 12C11.5434 12 13.4252 10.8173 14.7031 9.5535C15.5982 8.66087 16.3393 7.61854 16.8945 6.471C16.9639 6.32436 17 6.16343 17 6.00037C17 5.83732 16.9639 5.67639 16.8945 5.52975C16.3395 4.382 15.5988 3.33942 14.7038 2.4465C13.4252 1.18275 11.5434 0 9 0ZM7.53954 6C7.53954 5.60218 7.69341 5.22064 7.9673 4.93934C8.24119 4.65804 8.61266 4.5 9 4.5C9.38734 4.5 9.75881 4.65804 10.0327 4.93934C10.3066 5.22064 10.4605 5.60218 10.4605 6C10.4605 6.39782 10.3066 6.77936 10.0327 7.06066C9.75881 7.34196 9.38734 7.5 9 7.5C8.61266 7.5 8.24119 7.34196 7.9673 7.06066C7.69341 6.77936 7.53954 6.39782 7.53954 6ZM9 3C8.22533 3 7.48238 3.31607 6.9346 3.87868C6.38682 4.44129 6.07908 5.20435 6.07908 6C6.07908 6.79565 6.38682 7.55871 6.9346 8.12132C7.48238 8.68393 8.22533 9 9 9C9.77468 9 10.5176 8.68393 11.0654 8.12132C11.6132 7.55871 11.9209 6.79565 11.9209 6C11.9209 5.20435 11.6132 4.44129 11.0654 3.87868C10.5176 3.31607 9.77468 3 9 3Z"
      :fill="isError ? '#FF4141' : '#304156'"
    />
    <path
      d="M1 2L17 10"
      :stroke="isError ? '#FF4141' : '#304156'"
      stroke-width="1.7"
      stroke-linecap="round"
    />
  </svg>

  <svg
    v-if="name === 'tableStatusWithdraw'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM10 9H6V11H10V14L14 10L10 6V9Z"
      fill="#99AAC2"
    />
  </svg>

  <svg
    v-if="name === 'tableStatusUnverifiedUsers'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4989_32080)">
      <path
        d="M13.3692 11.667H6.63083C5.53567 11.6683 4.48575 12.104 3.71135 12.8783C2.93696 13.6527 2.50132 14.7027 2.5 15.7978V20.0003H17.5V15.7978C17.4987 14.7027 17.063 13.6527 16.2886 12.8783C15.5143 12.104 14.4643 11.6683 13.3692 11.667V11.667Z"
        fill="#90C8EB"
      />
      <path
        d="M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z"
        fill="#90C8EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_4989_32080">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-if="name === 'tableStatusUnverifiedRE'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16667 0H2.5C1.83696 0 1.20107 0.263392 0.732233 0.732233C0.263392 1.20107 0 1.83696 0 2.5L0 20H11.6667V2.5C11.6667 1.83696 11.4033 1.20107 10.9344 0.732233C10.4656 0.263392 9.82971 0 9.16667 0V0ZM5 15.8333H2.5V14.1667H5V15.8333ZM5 12.5H2.5V10.8333H5V12.5ZM5 9.16667H2.5V7.5H5V9.16667ZM5 5.83333H2.5V4.16667H5V5.83333ZM9.16667 15.8333H6.66667V14.1667H9.16667V15.8333ZM9.16667 12.5H6.66667V10.8333H9.16667V12.5ZM9.16667 9.16667H6.66667V7.5H9.16667V9.16667ZM9.16667 5.83333H6.66667V4.16667H9.16667V5.83333ZM17.5 4.16667H13.3333V20H20V6.66667C20 6.00363 19.7366 5.36774 19.2678 4.8989C18.7989 4.43006 18.163 4.16667 17.5 4.16667ZM17.5 15.8333H15.8333V14.1667H17.5V15.8333ZM17.5 12.5H15.8333V10.8333H17.5V12.5ZM17.5 9.16667H15.8333V7.5H17.5V9.16667Z"
      fill="#90C8EB"
    />
  </svg>

  <svg
    v-if="name === 'tableStatusUnverifiedContracts'"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.49984 10.8335V13.3335H11.4998V10.8335H17.3332V16.6668C17.3332 16.8878 17.2454 17.0998 17.0891 17.2561C16.9328 17.4124 16.7209 17.5002 16.4998 17.5002H1.49984C1.27882 17.5002 1.06686 17.4124 0.910582 17.2561C0.754301 17.0998 0.666504 16.8878 0.666504 16.6668V10.8335H6.49984ZM8.1665 9.16683H9.83317V11.6668H8.1665V9.16683ZM4.83317 4.16683V1.66683C4.83317 1.44582 4.92097 1.23385 5.07725 1.07757C5.23353 0.921293 5.44549 0.833496 5.6665 0.833496H12.3332C12.5542 0.833496 12.7661 0.921293 12.9224 1.07757C13.0787 1.23385 13.1665 1.44582 13.1665 1.66683V4.16683H16.4998C16.7209 4.16683 16.9328 4.25463 17.0891 4.41091C17.2454 4.56719 17.3332 4.77915 17.3332 5.00016V9.16683H11.4998V7.50016H6.49984V9.16683H0.666504V5.00016C0.666504 4.77915 0.754301 4.56719 0.910582 4.41091C1.06686 4.25463 1.27882 4.16683 1.49984 4.16683H4.83317ZM6.49984 2.50016V4.16683H11.4998V2.50016H6.49984Z"
      fill="#90C8EB"
    />
  </svg>

  <svg
    v-if="name === 'adjustmentStatusRejected'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C19.994 4.47961 15.5204 0.00597656 10 0ZM13.3333 12.1558C13.672 12.4675 13.6938 12.9947 13.3821 13.3333C13.0705 13.672 12.5433 13.6938 12.2046 13.3821C12.1877 13.3666 12.1714 13.3503 12.1558 13.3333L10 11.1783L7.845 13.3333C7.51395 13.653 6.98641 13.6439 6.66668 13.3128C6.3548 12.9899 6.3548 12.4779 6.66668 12.155L8.82168 10L6.66668 7.845C6.34695 7.51395 6.35613 6.98641 6.68719 6.66668C7.01012 6.3548 7.52207 6.3548 7.845 6.66668L10 8.82168L12.1558 6.66668C12.4675 6.32805 12.9947 6.30617 13.3333 6.61785C13.672 6.92953 13.6938 7.45672 13.3821 7.79535C13.3666 7.8123 13.3503 7.82856 13.3333 7.84418L11.1783 10L13.3333 12.1558Z"
      fill="#FF4141"
    />
  </svg>

  <svg
    v-if="name === 'adjustmentStatusPending'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.34591 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34872 18.9427 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0V0ZM10.8333 9.89917C10.8334 10.0404 10.7976 10.1794 10.7292 10.303C10.6609 10.4266 10.5622 10.5308 10.4425 10.6058L7.24251 12.6058C7.14949 12.6639 7.04593 12.7032 6.93775 12.7213C6.82958 12.7393 6.7189 12.7359 6.61203 12.7113C6.50517 12.6866 6.40421 12.6411 6.31493 12.5774C6.22564 12.5137 6.14978 12.433 6.09167 12.34C6.03356 12.247 5.99434 12.1434 5.97625 12.0353C5.95816 11.9271 5.96156 11.8164 5.98624 11.7095C6.01093 11.6027 6.05642 11.5017 6.12012 11.4124C6.18382 11.3231 6.26449 11.2473 6.3575 11.1892L9.16667 9.4375V5.83333C9.16667 5.61232 9.25447 5.40036 9.41075 5.24408C9.56703 5.0878 9.77899 5 10 5C10.221 5 10.433 5.0878 10.5893 5.24408C10.7455 5.40036 10.8333 5.61232 10.8333 5.83333V9.89917Z"
      fill="#FFD951"
    />
  </svg>

  <svg
    v-if="name === 'adjustmentStatusConfirmed'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 0C15.523 0 20 4.47701 20 10C20 15.523 15.523 20 10 20C4.47701 20 0 15.523 0 10C0 4.47701 4.47701 0 10 0ZM8.85725 13.7765L14.7073 7.9265C15.0983 7.5365 15.0983 6.9035 14.7073 6.5125C14.3163 6.1225 13.6842 6.1225 13.2933 6.5125L8.85725 10.9485L6.70725 8.7985C6.31625 8.4075 5.68425 8.4075 5.29325 8.7985C4.90225 9.1895 4.90225 9.8215 5.29325 10.2125L8.85725 13.7765Z"
      fill="#59CB47"
    />
  </svg>

  <svg
    v-if="name === 'walletHeader'"
    class="icon"
    width="25"
    height="23"
    viewBox="0 0 25 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4541 13.5444C18.0009 13.5444 18.4875 13.3368 18.914 12.9215C19.3406 12.5063 19.5538 12.0218 19.5538 11.4681C19.5538 10.9356 19.3406 10.4671 18.914 10.0625C18.4875 9.65787 18.0009 9.45555 17.4541 9.45555C16.9073 9.45555 16.4206 9.65787 15.9941 10.0625C15.5676 10.4671 15.3543 10.9356 15.3543 11.4681C15.3543 12.0218 15.5676 12.5063 15.9941 12.9215C16.4206 13.3368 16.9073 13.5444 17.4541 13.5444ZM1.9685 19.3903C1.9685 19.3903 1.9685 19.6725 1.9685 20.2368C1.9685 20.8012 1.9685 21.0833 1.9685 21.0833V1.91667C1.9685 1.91667 1.9685 2.20417 1.9685 2.77917C1.9685 3.35417 1.9685 3.64167 1.9685 3.64167C1.9685 3.64167 1.9685 4.0463 1.9685 4.85556C1.9685 5.66481 1.9685 6.67639 1.9685 7.89028V15.1417C1.9685 16.3556 1.9685 17.3671 1.9685 18.1764C1.9685 18.9856 1.9685 19.3903 1.9685 19.3903ZM1.9685 23C1.46544 23 1.01159 22.8083 0.606956 22.425C0.202319 22.0417 0 21.5944 0 21.0833V1.91667C0 1.42685 0.202319 0.984954 0.606956 0.590972C1.01159 0.196991 1.46544 0 1.9685 0H21.6535C22.1785 0 22.6378 0.196991 23.0315 0.590972C23.4252 0.984954 23.622 1.42685 23.622 1.91667V6.19722H21.6535V1.91667H1.9685V21.0833H21.6535V16.8347H23.622V21.0833C23.622 21.5944 23.4252 22.0417 23.0315 22.425C22.6378 22.8083 22.1785 23 21.6535 23H1.9685ZM13.7139 17.4736C12.9703 17.4736 12.3797 17.2606 11.9423 16.8347C11.5048 16.4088 11.2861 15.8444 11.2861 15.1417V7.89028C11.2861 7.1662 11.5048 6.59653 11.9423 6.18125C12.3797 5.76597 12.9703 5.55833 13.7139 5.55833H22.5722C23.3158 5.55833 23.9064 5.76597 24.3438 6.18125C24.7813 6.59653 25 7.1662 25 7.89028V15.1417C25 15.8444 24.7813 16.4088 24.3438 16.8347C23.9064 17.2606 23.3158 17.4736 22.5722 17.4736H13.7139ZM23.0315 15.5569V7.475H13.2546V15.5569H23.0315Z"
      fill="black"
    />
  </svg>

  <svg
    v-if="name === 'walletHeaderMobile'"
    class="icon-mobile"
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 3.99984H4.16667C3.45083 3.99984 2.77333 3.68984 2.30417 3.16734C2.7625 2.65567 3.42833 2.33317 4.16667 2.33317H19.1667C20.2567 2.32817 20.2558 0.670671 19.1667 0.666504H4.16667C1.86583 0.666504 0 2.53234 0 4.83317V13.1665C0 15.4673 1.86583 17.3332 4.16667 17.3332H17.5C18.8808 17.3332 20 16.214 20 14.8332V6.49984C20 5.119 18.8808 3.99984 17.5 3.99984ZM16.6667 11.4998C15.5767 11.4948 15.5767 9.83817 16.6667 9.83317C17.7567 9.83817 17.7567 11.4948 16.6667 11.4998Z"
      fill="#304156"
    />
  </svg>
  <svg
    v-if="name === 'walletStatusComplete'"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5 0C11.6422 0 15 3.35776 15 7.5C15 11.6422 11.6422 15 7.5 15C3.35776 15 0 11.6422 0 7.5C0 3.35776 3.35776 0 7.5 0ZM6.64294 10.3324L11.0304 5.94488C11.3237 5.65238 11.3237 5.17762 11.0304 4.88437C10.7372 4.59188 10.2632 4.59188 9.96994 4.88437L6.64294 8.21138L5.03044 6.59888C4.73719 6.30562 4.26319 6.30562 3.96994 6.59888C3.67669 6.89213 3.67669 7.36613 3.96994 7.65938L6.64294 10.3324Z"
      fill="#59CB47"
    />
  </svg>
  <svg
    v-if="name === 'walletStatusPending'"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 7.5C15 8.98336 14.5601 10.4334 13.736 11.6668C12.9119 12.9001 11.7406 13.8614 10.3701 14.4291C8.99968 14.9968 7.49168 15.1453 6.03683 14.8559C4.58197 14.5665 3.2456 13.8522 2.1967 12.8033C1.14781 11.7544 0.433503 10.418 0.144114 8.96318C-0.145275 7.50832 0.00324965 6.00032 0.570907 4.62988C1.13856 3.25943 2.09986 2.08809 3.33323 1.26398C4.5666 0.439867 6.01664 0 7.5 0C9.48847 0.00215068 11.3949 0.793018 12.8009 2.19907C14.207 3.60513 14.9979 5.51154 15 7.5ZM8.75 7.5C8.75 7.16848 8.61831 6.85054 8.38389 6.61612C8.14947 6.3817 7.83152 6.25 7.5 6.25H6.25V7.5H7.5V11.875H8.75V7.5ZM7.5 3.125C7.31458 3.125 7.13333 3.17998 6.97916 3.283C6.82499 3.38601 6.70482 3.53243 6.63387 3.70373C6.56291 3.87504 6.54434 4.06354 6.58052 4.2454C6.61669 4.42726 6.70598 4.5943 6.83709 4.72541C6.9682 4.85653 7.13525 4.94581 7.31711 4.98199C7.49896 5.01816 7.68746 4.9996 7.85877 4.92864C8.03008 4.85768 8.17649 4.73752 8.27951 4.58335C8.38252 4.42918 8.4375 4.24792 8.4375 4.0625C8.4375 3.81386 8.33873 3.5754 8.16292 3.39959C7.9871 3.22377 7.74864 3.125 7.5 3.125Z"
      fill="#FFD951"
    />
  </svg>

  <svg
    v-if="name === 'walletStatusFailed'"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15C11.6421 15 15 11.6421 15 7.5C14.9955 3.35971 11.6403 0.00448242 7.5 0ZM9.99999 9.11687C10.254 9.35063 10.2704 9.74602 10.0366 9.99999C9.80285 10.254 9.40746 10.2704 9.15349 10.0366C9.14077 10.0249 9.12858 10.0127 9.11687 9.99999L7.5 8.38374L5.88375 9.99999C5.63546 10.2398 5.2398 10.2329 5.00001 9.98461C4.7661 9.74241 4.7661 9.35845 5.00001 9.11625L6.61626 7.5L5.00001 5.88375C4.76021 5.63546 4.7671 5.2398 5.01539 5.00001C5.25759 4.7661 5.64155 4.7661 5.88375 5.00001L7.5 6.61626L9.11687 5.00001C9.35063 4.74604 9.74602 4.72963 9.99999 4.96339C10.254 5.19715 10.2704 5.59254 10.0366 5.84651C10.0249 5.85923 10.0127 5.87142 9.99999 5.88313L8.38374 7.5L9.99999 9.11687Z"
      fill="#FF4141"
    />
  </svg>

  <svg
    v-if="name === 'contracts'"
    class="icon"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.832 7.24023H4.16536C3.01477 7.24023 2.08203 8.17297 2.08203 9.32357V19.7402C2.08203 20.8908 3.01477 21.8236 4.16536 21.8236H20.832C21.9826 21.8236 22.9154 20.8908 22.9154 19.7402V9.32357C22.9154 8.17297 21.9826 7.24023 20.832 7.24023Z"
      stroke="#304156"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="bevel"
    />
    <path
      d="M7.29102 7.07357V5.26107C7.29102 4.70853 7.51051 4.17863 7.90121 3.78793C8.29191 3.39723 8.82181 3.17773 9.37435 3.17773H15.6243C16.1769 3.17773 16.7068 3.39723 17.0975 3.78793C17.4882 4.17863 17.7077 4.70853 17.7077 5.26107V7.07357"
      stroke="#304156"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="bevel"
    />
  </svg>

  <svg
    v-if="name === 'contractsMobile'"
    class="icon-mobile"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4062_27430)">
      <path
        d="M15.8333 3.33333H14.9167C14.7233 2.39284 14.2115 1.54779 13.4677 0.940598C12.7239 0.333408 11.7935 0.0012121 10.8333 0L9.16667 0C8.2065 0.0012121 7.2761 0.333408 6.53229 0.940598C5.78848 1.54779 5.27675 2.39284 5.08333 3.33333H4.16667C3.062 3.33466 2.00296 3.77407 1.22185 4.55518C0.440735 5.3363 0.00132321 6.39534 0 7.5L0 10H20V7.5C19.9987 6.39534 19.5593 5.3363 18.7782 4.55518C17.997 3.77407 16.938 3.33466 15.8333 3.33333ZM6.82 3.33333C6.99174 2.84758 7.30936 2.42674 7.72942 2.12841C8.14948 1.83007 8.65145 1.6688 9.16667 1.66667H10.8333C11.3485 1.6688 11.8505 1.83007 12.2706 2.12841C12.6906 2.42674 13.0083 2.84758 13.18 3.33333H6.82Z"
        fill="#304156"
      />
      <path
        d="M10.8333 12.5003C10.8333 12.7213 10.7455 12.9333 10.5893 13.0896C10.433 13.2459 10.221 13.3337 10 13.3337C9.77899 13.3337 9.56702 13.2459 9.41074 13.0896C9.25446 12.9333 9.16667 12.7213 9.16667 12.5003V11.667H0V15.8337C0.00132321 16.9383 0.440735 17.9974 1.22185 18.7785C2.00296 19.5596 3.062 19.999 4.16667 20.0003H15.8333C16.938 19.999 17.997 19.5596 18.7782 18.7785C19.5593 17.9974 19.9987 16.9383 20 15.8337V11.667H10.8333V12.5003Z"
        fill="#304156"
      />
    </g>
    <defs>
      <clipPath id="clip0_4062_27430">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-if="name === 'contractsBackBtn'"
    class="icon"
    width="25"
    height="26"
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.832 7.73975H4.16536C3.01477 7.73975 2.08203 8.67249 2.08203 9.82308V20.2397C2.08203 21.3903 3.01477 22.3231 4.16536 22.3231H20.832C21.9826 22.3231 22.9154 21.3903 22.9154 20.2397V9.82308C22.9154 8.67249 21.9826 7.73975 20.832 7.73975Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="bevel"
    />
    <path
      d="M7.29102 7.57308V5.76058C7.29102 5.20805 7.51051 4.67814 7.90121 4.28744C8.29191 3.89674 8.82181 3.67725 9.37435 3.67725H15.6243C16.1769 3.67725 16.7068 3.89674 17.0975 4.28744C17.4882 4.67814 17.7077 5.20805 17.7077 5.76058V7.57308"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="bevel"
    />
  </svg>

  <svg
    v-if="name === 'contractsMobileBackBtn'"
    class="icon-mobile"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1632_22125)">
      <path
        d="M15.8333 3.33333H14.9167C14.7233 2.39284 14.2115 1.54779 13.4677 0.940598C12.7239 0.333408 11.7935 0.0012121 10.8333 0L9.16667 0C8.2065 0.0012121 7.2761 0.333408 6.53229 0.940598C5.78848 1.54779 5.27675 2.39284 5.08333 3.33333H4.16667C3.062 3.33466 2.00296 3.77407 1.22185 4.55518C0.440735 5.3363 0.00132321 6.39534 0 7.5L0 10H20V7.5C19.9987 6.39534 19.5593 5.3363 18.7782 4.55518C17.997 3.77407 16.938 3.33466 15.8333 3.33333V3.33333ZM6.82 3.33333C6.99174 2.84758 7.30936 2.42674 7.72942 2.12841C8.14948 1.83007 8.65145 1.6688 9.16667 1.66667H10.8333C11.3486 1.6688 11.8505 1.83007 12.2706 2.12841C12.6906 2.42674 13.0083 2.84758 13.18 3.33333H6.82Z"
        fill="white"
      />
      <path
        d="M10.8333 12.5003C10.8333 12.7213 10.7455 12.9333 10.5893 13.0896C10.433 13.2459 10.221 13.3337 10 13.3337C9.77899 13.3337 9.56702 13.2459 9.41074 13.0896C9.25446 12.9333 9.16667 12.7213 9.16667 12.5003V11.667H0V15.8337C0.00132321 16.9383 0.440735 17.9974 1.22185 18.7785C2.00296 19.5596 3.062 19.999 4.16667 20.0003H15.8333C16.938 19.999 17.997 19.5596 18.7782 18.7785C19.5593 17.9974 19.9987 16.9383 20 15.8337V11.667H10.8333V12.5003Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1632_22125">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-else-if="name === 'language-switch-white'"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 20C15.7467 20 20 15.7467 20 10.5C20 5.25329 15.7467 1 10.5 1M10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1M10.5 20C13.0909 20 13.9545 15.6818 13.9545 10.5C13.9545 5.31818 13.0909 1 10.5 1M10.5 20C7.90909 20 7.04545 15.6818 7.04545 10.5C7.04545 5.31818 7.90909 1 10.5 1M1.86364 13.9545H19.1364M1.86364 7.04545H19.1364"
      stroke="white"
      stroke-width="1.5"
    />
  </svg>

  <svg
    v-if="name === 'adjustmentHeader'"
    class="icon"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.9167 24.999H2.08333V22.9156H22.9167V24.999ZM25 16.6656C25 14.9427 23.5979 13.5406 21.875 13.5406H16.6667C16.2458 13.5406 15.9875 13.3083 15.8698 13.1698C15.7531 13.0313 15.5687 12.7365 15.6406 12.3219C16.2437 8.85208 16.6656 5.49896 16.6656 4.16667C16.6656 1.86875 14.7969 0 12.499 0C10.201 0 8.33229 1.86875 8.33229 4.16667C8.33229 5.49688 8.75417 8.85104 9.35833 12.3219C9.43021 12.7365 9.24583 13.0313 9.12917 13.1698C9.0125 13.3083 8.75417 13.5406 8.33229 13.5406H3.125C1.40208 13.5406 0 14.9427 0 16.6656V20.8323H25V16.6656ZM2.08333 16.6656C2.08333 16.0917 2.55104 15.624 3.125 15.624H8.33333C9.25729 15.624 10.1292 15.2177 10.724 14.5104C11.3187 13.8021 11.5698 12.875 11.4115 11.9635C10.8344 8.65 10.4156 5.36979 10.4156 4.16563C10.4156 3.01667 11.35 2.08229 12.499 2.08229C13.6479 2.08229 14.5823 3.01667 14.5823 4.16563C14.5823 5.37292 14.1646 8.65208 13.5875 11.9635C13.4292 12.874 13.6792 13.8021 14.274 14.5094C14.8698 15.2177 15.7406 15.6229 16.6656 15.6229H21.874C22.449 15.6229 22.9156 16.0906 22.9156 16.6646V18.7479H2.08333V16.6646V16.6656Z"
      fill="#304156"
    />
  </svg>
  <svg
    v-if="name === 'adjustmentHeaderMobile'"
    class="icon-mobile"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3333 19.9999H1.66667V18.3332H18.3333V19.9999ZM20 13.3332C20 11.9549 18.8783 10.8332 17.5 10.8332H13.3333C12.9967 10.8332 12.79 10.6474 12.6958 10.5366C12.6025 10.4257 12.455 10.1899 12.5125 9.85823C12.995 7.0824 13.3325 4.3999 13.3325 3.33407C13.3325 1.49573 11.8375 0.000732422 9.99917 0.000732422C8.16083 0.000732422 6.66583 1.49573 6.66583 3.33407C6.66583 4.39823 7.00333 7.08157 7.48667 9.85823C7.54417 10.1899 7.39667 10.4257 7.30333 10.5366C7.21 10.6474 7.00333 10.8332 6.66583 10.8332H2.5C1.12167 10.8332 0 11.9549 0 13.3332V16.6666H20V13.3332Z"
      fill="#304156"
    />
  </svg>
</template>

<script>
export default {
  props: {
    name: { type: String, default: '' },
    isError: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';
@import '../../scss/mixins';

.icon {
  @include respond-to($tablet) {
    display: none;
  }

  &-mobile {
    display: none;

    @include respond-to($tablet) {
      display: block;
    }
  }
}
</style>
